import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Technologysa = () => {
  return (
    <div
      className="tekrevol_gray_bg tabing_section p-100"
      style={{ paddingBottom: "0px" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={10} lg={10} className="m-auto text-center">
            <h2>
              TekRevol’s Tech Stack for Mobile App Development in Riyadh, Saudi
              Arabia
            </h2>
            <p>
              Being among the top mobile app development companies in Saudi
              Arabia, we utilize the most cutting-edge technologies to tailor
              each app solution precisely to the unique demands of your project.
              Whether you're envisioning the development of an app for either
              iOS or Android, as one of the top-tier mobile app development
              companies in Riyadh, our comprehensive proficiency spans across
              all platforms and competencies to craft exceptional applications
              for your business. Meanwhile, our approach, founded on agile
              methodologies, guarantees a continuous and streamlined development
              journey.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Mobile App">
              <Row>
                <Col xs={12} md={6} lg={6} className="my-auto">
                  <h3 className="saudia_h3_head">Mobile App Development</h3>
                  <p>
                    Our app developers in Saudi Arabia construct customized apps
                    that always make use of the most recent and scalable
                    technology stack to meet the industry requirements.
                  </p>
                  <Link
                    to="/contact"
                    className="border_btn dark_btn"
                    aria-label="TekRevol Contact"
                  >
                    Talk to our Experts
                  </Link>
                </Col>
                <Col xs={12} md={6} lg={6} className="text-center">
                  <StaticImage
                    src="../../../images/locationgcc/sa/Mobile_App_Development.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={340}
                    height={500}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="2" title="Native App">
              <Row>
                <Col xs={12} md={6} lg={6} className="my-auto">
                  <h3 className="saudia_h3_head">Native App Development</h3>
                  <p>
                    We build platform-specific applications for optimal
                    performance and user satisfaction, resulting in higher
                    engagement and better retention rates.
                  </p>
                  <Link
                    to="/contact"
                    className="border_btn dark_btn"
                    aria-label="TekRevol Contact"
                  >
                    Talk to our Experts
                  </Link>
                </Col>
                <Col xs={12} md={6} lg={6} className="text-center">
                  <StaticImage
                    src="../../../images/locationgcc/sa/Native_App_Development.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={340}
                    height={500}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="3" title="Hybrid App">
              <Row>
                <Col xs={12} md={6} lg={6} className="my-auto">
                  <h3 className="saudia_h3_head">Hybrid App Development</h3>
                  <p>
                    Hire our app developers in Saudi Arabia to create and
                    implement hybrid or cross-platform apps that will work
                    across several platforms while maintaining consistency and
                    providing an excellent user experience.
                  </p>
                  <Link
                    to="/contact"
                    className="border_btn dark_btn"
                    aria-label="TekRevol Contact"
                  >
                    Talk to our Experts
                  </Link>
                </Col>
                <Col xs={12} md={6} lg={6} className="text-center">
                  <StaticImage
                    src="../../../images/locationgcc/sa/Hybrid_App_Development.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={340}
                    height={500}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="4" title="Product Strategy">
              <Row>
                <Col xs={12} md={6} lg={6} className="my-auto">
                  <h3 className="saudia_h3_head">
                    Product Strategy Development
                  </h3>
                  <p>
                    Our consultants provide a clear roadmap and vision for your
                    product, aligning it with market needs and business
                    objectives. We craft a strategic plan to ensure the success
                    and growth of your product.
                  </p>
                  <Link
                    to="/contact"
                    className="border_btn dark_btn"
                    aria-label="TekRevol Contact"
                  >
                    Talk to our Experts
                  </Link>
                </Col>
                <Col xs={12} md={6} lg={6} className="text-center">
                  <StaticImage
                    src="../../../images/locationgcc/sa/Product_Strategy_Development.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={340}
                    height={500}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="5" title="E-Commerce App">
              <Row>
                <Col xs={12} md={6} lg={6} className="my-auto">
                  <h3 className="saudia_h3_head">E-Commerce App Development</h3>
                  <p>
                    Our e-commerce apps provide an exquisite design that has
                    been iterated and developed by our marketing professionals,
                    as well as unprecedented functionality that generates more
                    sales and conversions.
                  </p>
                  <Link
                    to="/contact"
                    className="border_btn dark_btn"
                    aria-label="TekRevol Contact"
                  >
                    Talk to our Experts
                  </Link>
                </Col>
                <Col xs={12} md={6} lg={6} className="text-center">
                  <StaticImage
                    src="../../../images/locationgcc/sa/E-Commerce_App_Development.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={340}
                    height={500}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="6" title="B2B App">
              <Row>
                <Col xs={12} md={6} lg={6} className="my-auto">
                  <h3 className="saudia_h3_head">B2B App Development</h3>
                  <p>
                    By offering customized solutions focused on scalability and
                    efficiency, we empower organizations to optimize their
                    workflows and drive growth in the B2B space.
                  </p>
                  <Link
                    to="/contact"
                    className="border_btn dark_btn"
                    aria-label="TekRevol Contact"
                  >
                    Talk to our Experts
                  </Link>
                </Col>
                <Col xs={12} md={6} lg={6} className="text-center">
                  <StaticImage
                    src="../../../images/locationgcc/sa/B2B_App_Development.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={340}
                    height={500}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologysa;
